import React, { useState } from 'react';
import 'react-image-lightbox/style.css';
import Lightbox from 'react-image-lightbox';
import { GridList, GridListTile, isWidthUp, withWidth } from '@material-ui/core';
import { useStyles } from './DamageInspection.styled';

const FormsDamageInspection = ({ width, event, images, comments, damageImage, damageLocation }) => {
  const classes = useStyles();
  const [isOpen, setIsOpen] = useState(false);

  /**
   * Get grid list cols
   */
  const getGridListCols = () => {
    if (isWidthUp('xl', width)) {
      return 4;
    }

    if (isWidthUp('lg', width)) {
      return 4;
    }

    if (isWidthUp('md', width)) {
      return 3;
    }

    return 2;
  };

  return (
    <>
      <div>
        <label className={classes.label}>{event?.label}:</label>{' '}
        <span className={classes.value}>{event?.response}</span>
      </div>
      <div>
        <label className={classes.label}>{damageLocation?.label}:</label>{' '}
        <span className={classes.value}>{damageLocation?.response}</span>
      </div>
      <div className={classes.divider}></div>
      {comments && (
        <div className={classes.comments}>
          <label>{comments?.label}</label>
          <br />
          <div className={classes.value}>{comments?.response}</div>
        </div>
      )}
      {damageImage?.reference_url && (
        <GridList
          spacing={8}
          cellHeight={100}
          className={classes.gridList}
          cols={getGridListCols()}
        >
          <GridListTile
            classes={{ imgFullHeight: classes.images }}
            className={classes.imagesEvent}
            cols={1}
          >
            <figure>
              <img
                src={damageImage?.reference_url}
                alt={damageImage?.response}
                onClick={() => setIsOpen(true)}
              />
              <figcaption>{damageImage?.response}</figcaption>
            </figure>
          </GridListTile>
        </GridList>
      )}
      {isOpen && <Lightbox mainSrc={images[0]} onCloseRequest={() => setIsOpen(false)} />}
    </>
  );
};

export default withWidth()(FormsDamageInspection);
